"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormInsuranceContactsSchema = exports.getEmailValidationSchema = exports.getPhoneValidationSchema = exports.getProfileFormSchema = void 0;
const yup_1 = require("yup");
const constants_1 = require("../../constants");
const utils_1 = require("../../utils");
const i18n_1 = require("./i18n");
const errorMessages = i18n_1.i18nDefaultValues.AuthSchema.errors;
const getProfileFormSchema = (t) => {
    const notFilled = t('SMART:AuthSchema.errors.notFilled', errorMessages.notFilled);
    const maxLengthMessage = t('SMART:AuthSchema.errors.maxLength', errorMessages.maxLength);
    const maxLength100Message = t('SMART:AuthSchema.errors.maxLength100', errorMessages.maxLength100);
    const useCyrillic = t('SMART:AuthSchema.errors.useCyrillic', errorMessages.useCyrillic);
    const nameStartWithLetter = t('SMART:AuthSchema.errors.nameStartWithLetter', errorMessages.nameStartWithLetter);
    const lastnameStartWithLetter = t('SMART:AuthSchema.errors.lastnameStartWithLetter', errorMessages.lastnameStartWithLetter);
    const middleNameStartWithLetter = t('SMART:AuthSchema.errors.middleNameStartWithLetter', errorMessages.middleNameStartWithLetter);
    const insuranceFromAgeEighteen = t('SMART:AuthSchema.errors.insuranceFromAgeEighteen', errorMessages.insuranceFromAgeEighteen);
    const insuranceUpToAgeHundred = t('SMART:AuthSchema.errors.insuranceUpToAgeHundred', errorMessages.insuranceUpToAgeHundred);
    const passportFromYear1997 = t('SMART:AuthSchema.errors.passportFromYear1997', errorMessages.passportFromYear1997);
    const passportFromAgeFourteen = t('SMART:AuthSchema.errors.passportFromAgeFourteen', errorMessages.passportFromAgeFourteen);
    const invalidPassportFormat = t('SMART:AuthSchema.errors.invalidPassportFormat', errorMessages.invalidPassportFormat);
    const invalidPassportCodeFormat = t('SMART:AuthSchema.errors.invalidPassportCodeFormat', errorMessages.invalidPassportCodeFormat);
    const addressIsNotDefine = t('SMART:AuthSchema.errors.addressIsNotDefine', errorMessages.addressIsNotDefine);
    const defaultFioSchema = (0, yup_1.string)()
        .required(notFilled)
        .test('maxLength', maxLengthMessage, (value) => constants_1.MAX_LENGTH.test(value))
        .test('onlyCyrillic', useCyrillic, (value) => constants_1.ONLY_CYRILLIC.test(value));
    return (0, yup_1.object)().shape({
        name: defaultFioSchema.test('ONLY_LETTERS', nameStartWithLetter, (value) => constants_1.ONLY_LETTERS.test(value)),
        surname: defaultFioSchema.test('ONLY_LETTERS', lastnameStartWithLetter, (value) => constants_1.ONLY_LETTERS.test(value)),
        middlename: (0, yup_1.string)()
            .notRequired()
            .when({
            is: (value) => value?.length,
            then: () => defaultFioSchema
                .test('ONLY_LETTERS', middleNameStartWithLetter, (value) => constants_1.ONLY_LETTERS.test(value))
                .test('onlyCyrillic', useCyrillic, (value) => constants_1.ONLY_CYRILLIC.test(value)),
        }),
        birthday: (0, yup_1.date)()
            .required(notFilled)
            .nullable()
            .test('is-date', notFilled, (value) => value instanceof Date)
            .test('isAdult', insuranceFromAgeEighteen, (value) => (0, utils_1.calculateAge)(new Date(value)) >= 18)
            .test('tooOld', insuranceUpToAgeHundred, (value) => (0, utils_1.calculateAge)(new Date(value)) < 100),
        passport: (0, yup_1.string)()
            .required(notFilled)
            .test('invalidPassport', invalidPassportFormat, (value) => constants_1.PASSPORT_REG_EXP.test(value)),
        passportDate: (0, yup_1.date)()
            .required(notFilled)
            .nullable()
            .test('is-date', notFilled, (value) => value instanceof Date)
            .test('notEdult', passportFromYear1997, (value) => {
            if (value) {
                return (0, utils_1.checkDateBefore)(new Date(constants_1.INVALID_PASSPORT_DATE), value);
            }
        })
            .test('notFourteen', passportFromAgeFourteen, function (value) {
            const { birthday } = this.parent;
            if (!birthday || !value) {
                return true;
            }
            const minDate = new Date(birthday);
            minDate.setFullYear(minDate.getFullYear() + 14);
            return (0, utils_1.checkDateBetween)(new Date(value), minDate, new Date());
        }),
        passportByWho: (0, yup_1.string)()
            .required(notFilled)
            .test('onlyCyrillic', useCyrillic, (value) => constants_1.NON_LATIN_REG_EXP.test(value))
            .test('maxLength', maxLength100Message, (value) => constants_1.MAX_LENGTH_100.test(value)),
        passportCode: (0, yup_1.string)()
            .required(notFilled)
            .test('invalidPassportCode', invalidPassportCodeFormat, (value) => constants_1.PASSPORT_CODE_REG_EXP.test(value)),
        address: (0, yup_1.object)({
            value: (0, yup_1.string)().optional(),
            fias_id: (0, yup_1.string)().optional(),
            fias_level: (0, yup_1.string)().optional(),
        })
            .required(notFilled)
            .test('addressIsNotDefine', addressIsNotDefine, (value) => !!value.fias_id &&
            (value.fias_level === constants_1.FiasLevel.HOUSE ||
                value.fias_level === constants_1.FiasLevel.APARTMENT)),
    }, [['middlename', 'middlename']]);
};
exports.getProfileFormSchema = getProfileFormSchema;
const getPhoneValidationSchema = (t, agentLogin) => {
    const enterPhone = t('SMART:AuthSchema.errors.enterPhone', errorMessages.enterPhone);
    const wrongPhone = t('SMART:AuthSchema.errors.wrongPhone', errorMessages.wrongPhone);
    const numberMatchesAgent = t('SMART:AuthSchema.errors.numberMatchesAgent', errorMessages.numberMatchesAgent);
    return (0, yup_1.string)()
        .required(enterPhone)
        .test('validPhone', wrongPhone, (value) => constants_1.PHONE_REG_EXP.test(value))
        .test('isAgentPhone', numberMatchesAgent, (value) => agentLogin ? (0, utils_1.phoneValueCasting)(value) !== agentLogin : true);
};
exports.getPhoneValidationSchema = getPhoneValidationSchema;
const getEmailValidationSchema = (t) => {
    const maxLengthMessage = t('SMART:AuthSchema.errors.maxLength', errorMessages.maxLength);
    const enterEmail = t('SMART:AuthSchema.errors.enterEmail', errorMessages.enterEmail);
    const incorrectEmail = t('SMART:AuthSchema.errors.incorrectEmail', errorMessages.incorrectEmail);
    return (0, yup_1.string)()
        .required(enterEmail)
        .test('validEmail', incorrectEmail, (value) => !!value && constants_1.EMAIL_REG_EXP.test(value))
        .test('maxLength', maxLengthMessage, (value) => constants_1.MAX_LENGTH.test(value));
};
exports.getEmailValidationSchema = getEmailValidationSchema;
const getFormInsuranceContactsSchema = (t, agentLogin) => {
    return (0, exports.getProfileFormSchema)(t).shape({
        email: (0, exports.getEmailValidationSchema)(t),
        phone: (0, exports.getPhoneValidationSchema)(t, agentLogin),
        hasAuthorized: (0, yup_1.boolean)(),
        client: (0, yup_1.boolean)(),
        forMe: (0, yup_1.boolean)(),
        isValid: (0, yup_1.boolean)(),
    });
};
exports.getFormInsuranceContactsSchema = getFormInsuranceContactsSchema;
